"use strict";

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefSequenceResult = void 0;
var BaseResult = /*#__PURE__*/function () {
  function BaseResult(args) {
    _classCallCheck(this, BaseResult);
    this.label = args.label;
    this.locString = args.locString;
    this.renderingComponent = args.renderingComponent;
    this.displayString = args.displayString;
    this.matchedAttribute = args.matchedAttribute;
    this.matchedObject = args.matchedObject;
    this.textSearchAdapter = args.textSearchAdapter;
    this.relevance = args.relevance;
    this.trackId = args.trackId;
    this.score = args.score || 1;
    this.results = args.results || [];
  }
  _createClass(BaseResult, [{
    key: "getLabel",
    value: function getLabel() {
      return this.label;
    }
  }, {
    key: "getDisplayString",
    value: function getDisplayString() {
      return this.displayString || this.label;
    }
  }, {
    key: "getRenderingComponent",
    value: function getRenderingComponent() {
      return this.renderingComponent;
    }
  }, {
    key: "getTrackId",
    value: function getTrackId() {
      return this.trackId;
    }
  }, {
    key: "getScore",
    value: function getScore() {
      return this.score;
    }
  }, {
    key: "updateScore",
    value: function updateScore(newScore) {
      this.score = newScore;
      return this.score;
    }
  }, {
    key: "getId",
    value: function getId() {
      return "".concat(this.getLabel(), "-").concat(this.getLocation(), "-").concat(this.getTrackId());
    }
  }, {
    key: "hasLocation",
    value: function hasLocation() {
      return !!this.locString;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.locString;
    }
  }, {
    key: "getComboResults",
    value: function getComboResults() {
      return this.results;
    }
  }]);
  return BaseResult;
}();
exports.default = BaseResult;
var RefSequenceResult = /*#__PURE__*/function (_BaseResult) {
  _inherits(RefSequenceResult, _BaseResult);
  function RefSequenceResult(args) {
    var _this;
    _classCallCheck(this, RefSequenceResult);
    var _a;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(RefSequenceResult).call(this, args));
    _this.refName = (_a = args.refName) !== null && _a !== void 0 ? _a : '';
    return _this;
  }
  _createClass(RefSequenceResult, [{
    key: "getLocation",
    value: function getLocation() {
      return this.refName;
    }
  }]);
  return RefSequenceResult;
}(BaseResult);
exports.RefSequenceResult = RefSequenceResult;